<div class="row justify-content-center">
    <div class="card col-md-10 p-20">
        <div *ngIf="texts" #info class="m-b-30"></div>
    </div>
</div>
